import React from 'react';

import { FulfillmentPicker as FulfillmentPickerComponent } from '../../../../components-shared/FulfillmentPicker';

import { useHooks } from './useHooks';

export const FulfillmentPicker = () => {
  const fulfillmentPickerProps = useHooks();

  return <FulfillmentPickerComponent {...fulfillmentPickerProps} />;
};
